import React from 'react';
import { Database, ArrowRight } from 'lucide-react';
import { useDbNavigate, useDatabaseSafe } from '../../context/DatabaseContext';
import { useAuth } from '../../context/AuthContext';

const modules = [
  {
    slug: 'estimating',
    label: 'Estimating',
    permKey: 'module.estimating',
    description: 'Manage estimating data including instrument and equipment schedules, IO lists, and field device assignments for project cost estimation.'
  },
  {
    slug: 'integration',
    label: 'Integration',
    permKey: 'module.integration',
    description: 'Manage integration data for PLC and SCADA systems including IO tags, network devices, panels, and platform configurations.'
  },
  {
    slug: 'submittals',
    label: 'Submittals',
    permKey: 'module.submittal',
    description: 'Track and manage submittal packages, vendor documentation, approval status, and transmittal records for project deliverables.'
  },
  {
    slug: 'sub-contractors',
    label: 'Sub Contractors',
    permKey: 'module.subcontractor',
    description: 'Manage subcontractor records, scope assignments, contact information, and associated work packages.'
  },
  {
    slug: 'purchasing',
    label: 'Purchasing',
    permKey: 'module.purchasing',
    description: 'Manage purchase orders, material requisitions, vendor assignments, and procurement status tracking.'
  },
  {
    slug: 'qaqc',
    label: 'QA/QC',
    permKey: 'module.qaqc',
    description: 'Manage quality assurance and quality control records including inspection checklists, test results, and punch list items.'
  },
  {
    slug: 'material-transfer',
    label: 'Material Transfer',
    permKey: 'module.transmittal',
    description: 'Track material transfer records, transmittals, and equipment delivery status across project locations.'
  },
  {
    slug: 'commissioning',
    label: 'Commissioning',
    permKey: 'module.commissioning',
    description: 'Manage commissioning activities including loop checks, OAT records, punch lists, and startup status by panel and system.'
  }
];

const DataEntryDashboardPage = () => {
  const navigate = useDbNavigate();
  const { hasPermission, isSysAdmin } = useAuth();
  const dbContext = useDatabaseSafe();
  const dbSlug = dbContext?.dbSlug || '';

  const canAccess = (permKey) => isSysAdmin || hasPermission(permKey, dbSlug);
  const visibleModules = modules.filter(m => canAccess(m.permKey));

  return (
    <div className="stui-dashboard-body">
      <div className="stui-dashboard-header">
        <Database size={20} className="stui-dashboard-header-icon" />
        <h1 className="stui-dashboard-header-title">Data Entry</h1>
        <span className="stui-dashboard-header-subtitle">
          {visibleModules.length} {visibleModules.length === 1 ? 'module' : 'modules'} available
        </span>
      </div>

      <div className="stui-dashboard-tile-grid">
        {modules.map(module => {
          const accessible = canAccess(module.permKey);
          return (
            <div
              key={module.slug}
              className={`stui-tile${accessible ? ' stui-clickable' : ' disabled'}`}
              onClick={() => accessible && navigate(`/${module.slug}`)}
            >
              <div className="stui-tile-header">
                <span className="stui-tile-title">{module.label}</span>
                {accessible
                  ? <ArrowRight size={16} className="stui-dashboard-tile-action" />
                  : <span className="stui-dashboard-tile-badge">No access</span>
                }
              </div>
              <div className="stui-dashboard-tile-content">
                <p className="stui-dashboard-tile-description">{module.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DataEntryDashboardPage;
